import { http } from '../utils/axios';
import { TPaginationResponse } from 'shared/types';
import { ILab } from 'shared/interfaces/lab.interface';

class LabService {
  private static instance: LabService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): LabService {
    if (!LabService.instance) {
      LabService.instance = new LabService();
    }

    return LabService.instance;
  }

  getLabs = async () => {
    const { data } = await http<TPaginationResponse<ILab[]>>({
      url: '/labs',
      method: 'GET',
      params: {}
    });

    return data;
  };
}

const instance = LabService.getInstance();

export default instance;
